module.exports = __webpack_public_path__ + "img/qrcode_s.edec1524.jpg";